import { render, staticRenderFns } from "./listenStu-manage.vue?vue&type=template&id=82308758&scoped=true"
import script from "./listenStu-manage.vue?vue&type=script&lang=js"
export * from "./listenStu-manage.vue?vue&type=script&lang=js"
import style0 from "./listenStu-manage.vue?vue&type=style&index=0&id=82308758&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82308758",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82308758')) {
      api.createRecord('82308758', component.options)
    } else {
      api.reload('82308758', component.options)
    }
    module.hot.accept("./listenStu-manage.vue?vue&type=template&id=82308758&scoped=true", function () {
      api.rerender('82308758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/listenStu-manage.vue"
export default component.exports